<script lang="ts" setup>
import { onMounted, ref, showErrorMsg } from '#imports';
import { getGradeList } from '~/api/common';

const gradeList = ref<any[]>([]);
const [model, modifiers] = defineModel('value', {
  type: Number,
  required: true,
  get: (value) => {
    //年级为空时后端默认值为0，不符合规范，这个值后端是透传的，不方便改，前端做处理
    if (modifiers.nonezero) {
      if (value === 0) return null;
    }
    return value;
  },

});

const props = defineProps({
  width: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    default: '',
  },
});

onMounted(() => {
  getGradeList()
    .then((res) => {
      gradeList.value = res;
    })
    .catch((err) => {
      showErrorMsg('获取年级列表失败', err);
    });
});
</script>
<template>
  <div>
    <a-select
      v-model:value="model"
      class="rounded-sm"
      :style="{ width }"
      :class="customClass"
      :placeholder="'请选择您的年级'"
      :options="gradeList"
      :field-names="{ label: 'gradeName', value: 'realGrade' }"
      :dropdown-match-select-width="false"
      size="large"
      @change="() => {}"
    >
      <template v-if="$slots.suffixIcon" #suffixIcon>
        <slot name="suffixIcon"></slot>
      </template>
    </a-select>
  </div>
</template>
<style scoped>
:deep(.ant-select-selector.ant-select-selector) {
  @apply !h-[52px] !rounded-[52px] !py-[4px]  !pl-[18px]  !text-base !shadow-none;
}
</style>
